
export const faqData = [
  {
    category: '견적/주문',
    question: '견적 요청은 어떻게 하나요?',
    answer: '견적 요청은 다음과 같은 방법으로 가능합니다:\n\n1. 상단 메뉴의 "구매 지원" 페이지에서 "견적 요청" 탭을 선택합니다.\n2. 필요한 제품 정보(카테고리, 제품명, 수량 등)를 입력합니다.\n3. 연락처 정보를 입력하고 "견적 요청하기" 버튼을 클릭합니다.\n4. 평균 24시간 내에 제조업체로부터 견적을 받으실 수 있습니다.\n\n여러 제조업체의 견적을 비교하고 싶으시다면, 제품 비교 기능을 활용해보세요.',
    relatedLinks: [
      { text: '견적 요청하기', url: '/buyer-tools' },
      { text: '제품 비교하기', url: '/buyer-tools' }
    ]
  },
  {
    category: '견적/주문',
    question: '최소 주문 수량이 있나요?',
    answer: '최소 주문 수량은 제조업체와 제품에 따라 다릅니다.\n\n대부분의 제조업체는 소량 주문도 가능하지만, 일부 특수 제품이나 맞춤 제작 제품의 경우 최소 주문 수량이 있을 수 있습니다.\n\n견적 요청 시 원하시는 수량을 입력하시면, 제조업체에서 가능 여부와 함께 견적을 보내드립니다.',
    relatedLinks: []
  },
  {
    category: '배송',
    question: '배송 기간은 얼마나 걸리나요?',
    answer: '배송 기간은 제품과 지역에 따라 다릅니다:\n\n• 재고 제품: 주문 후 2-5일 (영업일 기준)\n• 주문 제작 제품: 제작 기간 + 배송 기간 (평균 7-14일)\n• 긴급 배송: 별도 문의 (추가 비용 발생 가능)\n\n정확한 배송 기간은 견적서에 명시되며, 제조업체와 직접 협의하실 수 있습니다.',
    relatedLinks: [
      { text: '제조업체 찾기', url: '/manufacturers' }
    ]
  },
  {
    category: '배송',
    question: '전국 어디든 배송이 가능한가요?',
    answer: '네, 전국 모든 지역으로 배송이 가능합니다.\n\n특히 주요 항구 지역(부산, 여수, 목포, 포항, 제주 등)은 더욱 빠른 배송이 가능합니다.\n\n도서 지역이나 특수 지역의 경우 추가 배송비가 발생할 수 있으며, 이는 견적서에 명시됩니다.',
    relatedLinks: []
  },
  {
    category: '제품',
    question: '제품의 품질은 어떻게 보장되나요?',
    answer: '저희 플랫폼에 등록된 모든 제조업체는 엄격한 검증 절차를 거칩니다:\n\n• KS 인증, ISO 9001 등 공인 인증 보유 업체 우선 등록\n• 정기적인 품질 관리 및 고객 만족도 조사\n• 불량 제품 발생 시 교환/환불 보장\n• 제조업체별 평점 및 리뷰 시스템 운영\n\n또한 대부분의 제품은 제조업체의 품질 보증서가 함께 제공됩니다.',
    relatedLinks: [
      { text: '인증 제조업체 보기', url: '/manufacturers' }
    ]
  },
  {
    category: '제품',
    question: '맞춤 제작이 가능한가요?',
    answer: '네, 많은 제조업체에서 맞춤 제작 서비스를 제공합니다.\n\n맞춤 제작 가능 항목:\n• 특수 규격 및 사양\n• 선박별 맞춤 설계\n• 특수 재질 적용\n• 로고 및 마킹\n\n맞춤 제작을 원하시는 경우, 견적 요청 시 "제품 사양 및 요구사항" 란에 상세히 기재해주시면 제조업체에서 검토 후 답변드립니다.',
    relatedLinks: [
      { text: '견적 요청하기', url: '/buyer-tools' }
    ]
  },
  {
    category: '결제',
    question: '결제 방법은 어떻게 되나요?',
    answer: '결제는 제조업체와 직접 진행하시게 됩니다.\n\n일반적인 결제 방법:\n• 계좌 이체\n• 세금계산서 발행 후 결제\n• 현금 영수증 발행 가능\n• 일부 업체는 카드 결제 가능\n\n결제 조건(선불/후불, 분할 결제 등)은 제조업체와 협의하여 결정하실 수 있습니다.',
    relatedLinks: []
  },
  {
    category: '결제',
    question: '세금계산서 발행이 가능한가요?',
    answer: '네, 모든 제조업체는 세금계산서 발행이 가능합니다.\n\n세금계산서는 제품 배송 시 또는 결제 완료 후 이메일로 발송됩니다.\n\n사업자등록증을 제조업체에 제공하시면, 정확한 세금계산서를 받으실 수 있습니다.',
    relatedLinks: []
  },
  {
    category: '회원/계정',
    question: '회원 가입이 필수인가요?',
    answer: '아니요, 회원 가입 없이도 제품 검색과 제조업체 정보 확인이 가능합니다.\n\n하지만 회원 가입 시 다음과 같은 혜택이 있습니다:\n• 견적 요청 및 관리\n• 관심 제품/제조업체 저장\n• 주문 내역 조회\n• 맞춤형 제품 추천\n• 특별 할인 및 프로모션 정보\n\n회원 가입은 무료이며, 간단한 정보만 입력하시면 됩니다.',
    relatedLinks: []
  },
  {
    category: '회원/계정',
    question: '플랫폼 이용료가 있나요?',
    answer: '아니요, 저희 플랫폼은 선장/선주님들께 완전 무료로 제공됩니다.\n\n무료 서비스 항목:\n• 제품 검색 및 비교\n• 제조업체 정보 확인\n• 견적 요청\n• 고객 지원\n\n저희는 제조업체로부터 수수료를 받아 운영되므로, 구매자는 어떠한 비용도 부담하지 않으셔도 됩니다.',
    relatedLinks: []
  },
  {
    category: '견적/주문',
    question: '긴급 주문이 가능한가요?',
    answer: '네, 긴급 주문이 가능합니다.\n\n긴급 주문 절차:\n1. 견적 요청 시 "긴급" 표시 및 필요 날짜 명시\n2. 제조업체에서 긴급 생산/배송 가능 여부 확인\n3. 추가 비용 발생 시 사전 안내\n4. 최우선 처리\n\n재고가 있는 제품의 경우 당일 또는 익일 배송도 가능합니다.',
    relatedLinks: [
      { text: '긴급 견적 요청', url: '/buyer-tools' }
    ]
  },
  {
    category: '제품',
    question: '제품 샘플을 받아볼 수 있나요?',
    answer: '네, 대부분의 제조업체에서 샘플 제공이 가능합니다.\n\n샘플 요청 방법:\n• 견적 요청 시 "샘플 요청" 체크\n• 제조업체와 직접 연락하여 요청\n\n샘플 비용:\n• 소형 제품: 무료 또는 소액\n• 대형 제품: 실비 부담 (본 주문 시 환급 가능)\n\n샘플을 통해 제품의 품질을 직접 확인하신 후 주문하실 수 있습니다.',
    relatedLinks: []
  }
];
